import { Outlet } from 'react-router-dom'

import Directory from '../../components/directory/directory.component'

import {Credit} from './home.styles'

const Home = () => {
  return (
    <div>
      <Outlet />
      <Directory/>
      <Credit>
        Created By Mark Ajina
      </Credit>
    </div>
  );
}

export default Home;